import React from "react";
import classNames from "classnames";
import { Tooltip } from "@src/common/components";
import CourieButton from "@src/common/components/Button/Button";

interface OrderGroupLabelProps {
  orderGroupDisplayId: number;
  /** Cube's text for this order's place in its group, shown as it is. */
  label: string;
  isDispatchable: boolean;
  onOpen: () => void;
}

/**
 * "#123 · Leg 1 of 2" under an order number. Amber marks an order no driver runs, decided by the
 * order's dispatchable flag and never by reading the label text.
 */
export function OrderGroupLabel({
  orderGroupDisplayId,
  label,
  isDispatchable,
  onOpen,
}: OrderGroupLabelProps) {
  return (
    <Tooltip content="Open order group">
      <CourieButton
        color="link"
        size="xs"
        className={classNames("mt-0.5", !isDispatchable && "!text-amber-700 dark:!text-amber-400")}
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          // The row underneath selects itself on click; opening the group must not do that too.
          event.stopPropagation();
          onOpen();
        }}
        // The row also opens the edit form on double-click; a double-click on the label must not.
        onDoubleClick={(event: React.MouseEvent<HTMLButtonElement>) => event.stopPropagation()}
      >
        #{orderGroupDisplayId} · {label}
      </CourieButton>
    </Tooltip>
  );
}
